const styles = (theme) => ({
  bar: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    padding: theme.spacing(1.5, 0),
    marginBottom: theme.spacing(1),
    gap: theme.spacing(1),
  },
  summary: {
    marginRight: theme.spacing(2),
    color: theme.palette.text.primary,
    fontWeight: 500,
    flex: 1,
    minWidth: 200,
  },
  hint: {
    marginRight: theme.spacing(2),
    color: theme.palette.text.secondary,
    flex: 1,
    minWidth: 200,
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
});

export default styles;
